export default __webpack_public_path__ + "static/media/report-analytics.8ded1e3d.svg";